<template>
   <b-dropdown-item :to="{ name: 'impersonate' }" v-if="canImpersonate && !isImpersonating">
    Impersonate
  </b-dropdown-item>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'ImpersonateLink',
  computed: {
    ...mapGetters('impersonate', [
      'isImpersonating',
    ]),
    ...mapGetters('auth', [
      'hasPerm',
    ]),
    canImpersonate() {
      return this.hasPerm('dashboard.impersonate')
    }
  },
  methods: {}
}
</script>